// SkillsOverview.jsx - Skills and technologies overview
import React from 'react';
import { Card, Progress, Row, Col, Typography, Tag, Space } from 'antd';
import { 
  CodeOutlined,
  FormatPainterOutlined ,
  ToolOutlined,
  StarOutlined
} from '@ant-design/icons';

const { Title, Text } = Typography;

const SkillsOverview = () => {
  const skillCategories = {
    frontend: [
      { name: 'React', level: 90, color: '#61dafb' },
      { name: 'JavaScript', level: 85, color: '#f7df1e' },
      { name: 'TypeScript', level: 80, color: '#3178c6' },
      { name: 'CSS/SCSS/TailwindCSS', level: 88, color: '#1572b6' }
    ],
    backend: [
      { name: 'Node.js', level: 82, color: '#339933' },
      { name: 'Python', level: 70, color: '#3776ab' },
      { name: 'MongoDB', level: 75, color: '#47a248' },
      { name: 'PostgreSQL', level: 80, color: '#336791' },
      { name: 'GO', level: 80, color: '#09abd3' }
    ],
    design: [
      { name: 'Figma', level: 85, color: '#f24e1e' },
      { name: 'Adobe XD', level: 80, color: '#ff61f6' },
      { name: 'Photoshop', level: 95, color: '#31a8ff' },
      { name: 'Illustrator', level: 92, color: '#ff9a00' }
    ],
    tools: [
      { name: 'Git', level: 90, color: '#f05032' },
      { name: 'Docker', level: 75, color: '#2496ed' },
      { name: 'AWS', level: 70, color: '#ff9900' },
      { name: 'Jest', level: 80, color: '#c21325' }
    ]
  };

  const getCategoryIcon = (category) => {
    switch (category) {
      case 'frontend':
      case 'backend':
        return <CodeOutlined />;
      case 'design':
        return <FormatPainterOutlined  />;
      case 'tools':
        return <ToolOutlined />;
      default:
        return <StarOutlined />;
    }
  };

  const getCategoryTitle = (category) => {
    switch (category) {
      case 'frontend': return 'Frontend Development';
      case 'backend': return 'Backend Development';
      case 'design': return 'Design & UI/UX';
      case 'tools': return 'Tools & DevOps';
      default: return category;
    }
  };

  return (
    <Card 
      title={
        <div className="flex items-center space-x-2">
          <StarOutlined className="text-accent-blue" />
          <span>Skills Overview</span>
        </div>
      }
      className="shadow-medium border border-border-light rounded-xl"
    >
      <Row gutter={[24, 24]}>
        {Object.entries(skillCategories).map(([category, skills]) => (
          <Col xs={24} lg={12} key={category}>
            <div className="space-y-4">
              <div className="flex items-center space-x-2 mb-4">
                <span className="text-accent-blue text-lg">
                  {getCategoryIcon(category)}
                </span>
                <Title level={4} className="m-0 text-text-primary">
                  {getCategoryTitle(category)}
                </Title>
              </div>
              
              <Space direction="vertical" size="middle" className="w-full">
                {skills.map((skill, index) => (
                  <div key={index}>
                    <div className="flex items-center justify-between mb-2">
                      <div className="flex items-center space-x-2">
                        <Text className="text-text-primary font-medium">
                          {skill.name}
                        </Text>
                        <Tag 
                          color={skill.level >= 85 ? 'green' : skill.level >= 75 ? 'blue' : 'orange'}
                          size="small"
                        >
                          {skill.level >= 85 ? 'Expert' : skill.level >= 75 ? 'Advanced' : 'Intermediate'}
                        </Tag>
                      </div>
                      <Text className="text-text-secondary text-sm">
                        {skill.level}%
                      </Text>
                    </div>
                    <Progress 
                      percent={skill.level}
                      strokeColor={skill.color}
                      trailColor="#f1f5f9"
                      strokeWidth={6}
                      showInfo={false}
                    />
                  </div>
                ))}
              </Space>
            </div>
          </Col>
        ))}
      </Row>
    </Card>
  );
};

export default SkillsOverview;